import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Row, Button, Card, Container, Col, Dropdown, DropdownButton, Form, Badge } from 'react-bootstrap'
import * as Constants from './../../constants/constants.js';
import BootstrapTable from 'react-bootstrap-table-next';
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import {
    CellSelectionModule,
    ClipboardModule,
    ColumnMenuModule,
    ContextMenuModule,
    ExcelExportModule,
    IntegratedChartsModule,
} from "ag-grid-enterprise";
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import CustomTooltip from './CustomTooltip.js';
import { MDBIcon } from 'mdbreact';

export default function JobsTable(props) {
    const { jobs, openJobModal, openWO, saveJobChanges, sort, quickFilterText, employees = [] } = props
    const gridRef = useRef(null);
    
    const columnDefs = [
        {
            field: 'TimeIn',
            sort:"desc",
            valueFormatter: params => {
                return (Constants.dateTimeFormatter(params.value))
            }
        },
        {
            field: 'Name',
            valueGetter: params => {
                return (params.data.Lastname + ", " + params.data.Firstname)
            }
        },
        {
            field: 'Phone',
        },
        {
            field: 'Vehicle',
        },
        {
            field: 'Description',
            tooltipComponent: CustomTooltip,
            tooltipValueGetter: params => params.value
        },
        {
            field: 'Notes',
            tooltipComponent: CustomTooltip,
            tooltipValueGetter: params => params.value
        },
        {
            field: 'Status',
            filter: 'agSetColumnFilter',
            cellRenderer: params => {
                let color = ""; 
                let font = 'white'  
                console.log('params.value.toUpperCase()', params.value.toUpperCase());
                switch (params.value.toUpperCase()) {
                    case "OPEN":
                        color = "yellow";
                        font = "black"
                        break;
                    case "STARTED":
                        color = "green";
                        break;
                    case "FINISHED":
                        color = "blue";
                        break;
                    case "NEEDS APPROVAL":
                        color = "purple";
                        break;
                    case "NEEDS PARTS":
                        color = "red"
                        break;
                    default:
                        color = "gray";
                }

                return (
                    <Badge style={{ backgroundColor: color, color: font}}>
                        {params.value}
                    </Badge>
                );
            },
            
        },
        {
            field: 'Employee',
            headerName: 'Employee',
            cellRenderer: params => {
                if (!params.value) return null;
                return (
                    <div className="assigned-employee" style={{padding:"0px 10px", fontSize:"0.68rem"}}>
                        <MDBIcon icon='user' />
                        <span style={{ paddingLeft: "5px" }}>{params.value.split(' ')[0]}</span>
                    </div>
                );
            },
        },
    ]

    // useEffect(() => {
    //     if (!gridRef.current) return;
    
    //     let columnState = gridRef.current.api?.getColumnState();
    
    //     if (!columnState) return;

    //     // Update sort for the relevant column and clear sort for the other
    //     columnState = columnState.map(col => {
    //         if (col.colId === 'TimeIn') {
    //             return { ...col, sort: sort === 'Time' ? 'desc' : null };
    //         } else if (col.colId === 'Status') {
    //             return { ...col, sort: sort === 'Status' ? 'asc' : null };
    //         }
    //         return col;
    //     });

    //     // Apply the updated state
    //     gridRef.current.api?.applyColumnState({
    //         state: columnState,
    //         applyOrder: true
    //     });
    // }, [sort, gridRef]);
    


    return (
        <div className="ag-theme-alpine" style={{ width: "100%", padding: "8px", fontSize: "14px" }}>
  
            <AgGridReact
            domLayout="autoHeight"
            onRowClicked={(params)=>openJobModal(params.node.data)}
                suppressMultiSort={true}
                suppressCellFocus
                maintainColumnOrder
                ref={gridRef}
                columnDefs={columnDefs}
                rowData={jobs}
                tooltipShowDelay={0} 
                tooltipHideDelay={10000} 
                getRowClass={(params) => {
                    // Check if RowKey is null or undefined
                    if(params.node.data.Waiting)
                        return 'waiting-row'
            
                    return '';
                }}
                quickFilterText={quickFilterText}
                onSortChanged={(e)=>console.log('e', e)}
                getContextMenuItems={(params)=>{
                    return [
                        {
                            // custom item
                            name: "Open Job",
                            action: (params) => {
                                openJobModal(params.node.data)
                              console.log("Logging about ", params);
                            },
                        },
                        {
                            name: "Open Invoice",
                            action: (params) => {
                                openWO(params.node.data)
                              console.log("Logging about " + params.value);
                            },
                            disabled: params.node.data.WorkorderNumber === -1 ? true : false
                        },    
                        'separator',
                        {
                            name: 'Edit Status',
                            subMenu: [
                              {
                                name: 'Open',
                                action: () => saveJobChanges({...params.node.data, Status: "OPEN"}),
                              },
                              {
                                name: 'Started',
                                action: () => saveJobChanges({...params.node.data, Status: "STARTED"}),
                              },
                              {
                                name: 'Needs Approval',
                                action: () => saveJobChanges({...params.node.data, Status: "NEEDS APPROVAL"}),
                              },
                              {
                                name: 'Needs Parts',
                                action: () => saveJobChanges({...params.node.data, Status: "NEEDS PARTS"}),
                              },
                              {
                                name: 'Finished',
                                action: () => saveJobChanges({...params.node.data, Status: "FINISHED"}),
                              },
                            ],
                        },
                        {
                            name: 'Edit Employee',
                            subMenu: [
                              {
                                name: 'Unassign',
                                action: () => saveJobChanges({...params.node.data, Employee: ""}),
                              },
                              ...employees.map(emp => ({
                                name: emp.EmployeeName,
                                action: () => saveJobChanges({...params.node.data, Employee: emp.EmployeeName}),
                              })),
                            ],
                        },
                    ]
                }}

            />
        </div>
    )
}